import { render, staticRenderFns } from "./NFTDetail.vue?vue&type=template&id=6aec142b&scoped=true&"
import script from "./NFTDetail.vue?vue&type=script&lang=js&"
export * from "./NFTDetail.vue?vue&type=script&lang=js&"
import style0 from "./NFTDetail.vue?vue&type=style&index=0&id=6aec142b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec142b",
  null
  
)

export default component.exports